import React, { useEffect, useState } from 'react';

import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';

// mixin
const sizes = css`
  width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
  height: ${({ customheight }) => customheight !== null && customheight + 'px'};
`;

// Modal styling
const CustomModal = styled(Modal)`
  .modal-dialog {
    ${sizes}
    
    .modal-content {
      ${sizes}

      .modal-body {
        position: relative;
        display: table;
        padding: 0;

        img {
          max-width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
          max-height: ${({ customheight }) => customheight !== null && customheight + 'px'};
        }
      }
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
      margin: 1.75rem auto;
    }
  }
`;

const DisableCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2% 3%;
  background-color: #ffffff;
  user-select: none;
  font-size: 14px;
  background-color: whitesmoke;
  position: absolute;
  bottom: 0;
  width: 100%;

  .check-disable {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    visibility: hidden;

    label {
      margin: 0;
      margin-left: 5px;
      /* color: #8898aa; */
    }
  }

  .check-disable.show {
    visibility: visible;
  }

  .close-popup {
    cursor: pointer;
    /* color: #8898aa; */
  }
`;

function PreviewPopUp({ showPopUp, setShowPopUp, content, time, width, height }) {
  const [imageData, setImageData] = useState();

  useEffect(() => {
    if (content) {
      if (typeof content !== 'string') {
        let reader = new FileReader();
  
        reader.addEventListener('load', () => {
          setImageData(reader.result);
        });
  
        reader.readAsDataURL(content);
      } else {
        setImageData(content);
      }
    } else {
      setImageData();
    }
  }, [content]);

  return showPopUp ? (
    <CustomModal
      centered
      show={showPopUp}
      onHide={() => setShowPopUp(false)}
      animation={false}
      customwidth={width > 0 && width !== null ? width : null}
      customheight={height > 0 && height !== null ? height : null}
    >
      <Modal.Body>
        <img src={imageData} alt="" />
        <DisableCheckbox>
          <div className={`check-disable ${time > 0 && 'show'}`}>
            <input type="checkbox" id="closeChk" />
            <label htmlFor="closeChk">{time}시간동안 닫습니다.</label>
          </div>
          <span className="close-popup" onClick={() => setShowPopUp(false)}>
            닫기
          </span>
        </DisableCheckbox>
      </Modal.Body>
    </CustomModal>
  ) : null;
}

export default PreviewPopUp;
